module.exports = __webpack_public_path__ + "static/media/concat.78429426.bin";